/*
    自定义 toast 组件
    调用
    this.$didafe.toast('hello world~', {duration: 1500})
*/
import './toast.css';

const defaultOpts = {
  duration: 2500,     // Number
  wordWrap: false,    // Boolean
  width: ''
};

class Toast {
  constructor() {
    this.init();
  }

  static instance() {
    if (this.__instance) {
      return this.__instance;
    } 
      this.__instance = new Toast();
      return this.__instance;
    
  }

  init() {
    this.__opts = { ...defaultOpts};
    this.__dom = document.createElement('div');
    this.__dom.style.display = 'none';
    this.setOption();
    document.body.appendChild(this.__dom);
  }

  get dom() {
    return this.__dom;
  }

  setText(text) {
    this.__dom.innerText = text;
    return this;
  }

  setOption(text, opts) {
    this.__opts = { ...this.__opts, ...opts};
    // 字数超过16自动换行
    if (this.__opts.wordWrap || (text && text.length > 16)) {
      this.__dom.className = 'didafe-toast didafe-word-wrap';
    } else {
      this.__dom.className = 'didafe-toast';
    }
    if (this.__opts.width) {
      this.__dom.style.width = this.__opts.width;
    }
    if (this.__opts.top) {
      this.__dom.style.top = this.__opts.top;
    }
    return this;
  }

  show() {
    clearTimeout(this.__timer);
    this.__dom.style.display = 'block';
    return this;
  }

  hide() {
    clearTimeout(this.__timer);
    this.__timer = setTimeout(() => {
      this.__dom.style.display = 'none';
    }, this.__opts.duration);
    return this;
  }
}

export const toast = function(text, opts) {
  const toast = Toast.instance();
  toast.setOption(text, opts).setText(text).show().hide();
};

export default {
  install(Vue) {
    Vue.config.productionTip = false;
    Vue.prototype.$didafe = Vue.prototype.$didafe || {};
    Vue.prototype.$didafe.toast = toast;
  }
};
